var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlayVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 174,
    viewBox: "0 0 173 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86.4503,
    cy: 87.0683,
    r: 86.4508,
    fill: "#47CCDF",
    fillOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.1218,
    cy: 87.0685,
    r: 47.697,
    fill: "#333333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_5350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.2525 71.138C78.921 70.2907 77.1787 71.2472 77.1787 72.8254V101.311C77.1787 102.89 78.921 103.846 80.2525 102.999L102.634 88.7557C103.869 87.9698 103.869 86.167 102.634 85.3811L80.2525 71.138Z",
    fill: "#47CCDF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_5350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.7728,
    height: 35.7728,
    fill: "white",
    transform: "translate(68.2354 69.182)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayVideo);
export default __webpack_public_path__ + "static/media/icon-play-video.1ca99cc9c7e331eacf476fba7643fb74.svg";
export { ForwardRef as ReactComponent };